import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { MetaMaskProvider } from "@metamask/sdk-react";

import './index.css';
import {
  Navigation,
  Footer,
  Home,
  Image,
  Chat,
  Challenge,
  Scenario,
  Scenario1,
  Scenario2,
} from "./components";

ReactDOM.render(
  <MetaMaskProvider
    debug={false}
    sdkOptions={{
      dappMetadata: {
        name: "IceCream",
        url: window.location.href,
      },
      // Other options
    }}
  >
    <Router>
      <Navigation />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/image" element={<Image />} />
        <Route path="/chat" element={<Chat />} />
        <Route path="/challenge" element={<Challenge />} />
        <Route path="/scenario" element={<Scenario />} />
        <Route path="/scenario1" element={<Scenario1 />} />
        <Route path="/scenario2" element={<Scenario2 />} />
      </Routes>
      <Footer />
    </Router>
  </MetaMaskProvider>,

  document.getElementById("root")
);
